/**
 * @generated SignedSource<<b624800a667fe4a3cd8d738f727ee4c9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteGithubAttachedObjectInput = {
  id?: string | null;
  taskId?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type deleteGithubAttachedObjectMutation$variables = {
  input: DeleteGithubAttachedObjectInput;
};
export type deleteGithubAttachedObjectMutation$data = {
  readonly deleteGithubAttachedObject: {
    readonly deletedGithubAttachedObjectId: string | null;
  } | null;
};
export type deleteGithubAttachedObjectMutation = {
  variables: deleteGithubAttachedObjectMutation$variables;
  response: deleteGithubAttachedObjectMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteGithubAttachedObjectPayload",
    "kind": "LinkedField",
    "name": "deleteGithubAttachedObject",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedGithubAttachedObjectId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteGithubAttachedObjectMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteGithubAttachedObjectMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f0eb18835d06aa3b5d13f35798bfca8d",
    "id": null,
    "metadata": {},
    "name": "deleteGithubAttachedObjectMutation",
    "operationKind": "mutation",
    "text": "mutation deleteGithubAttachedObjectMutation(\n  $input: DeleteGithubAttachedObjectInput!\n) {\n  deleteGithubAttachedObject(input: $input) {\n    deletedGithubAttachedObjectId\n  }\n}\n"
  }
};
})();

(node as any).hash = "da16d7aff68157b2b99e52ac46da8dae";

export default node;
